import { useState } from "react"
import { CreateMessageDialog } from "../../../modules/merchant/admin/messages/components/CreateMessageDialog"
import { useOrderDialogUrlState } from "../../components/createOrder/hooks/useOrderDialogUrlState"
import { createTopBarNewMenuItem } from "../../components/topBarNewButtonMenu/topBarNewMenuItems"
import { TopBarNewButton } from "../../components/topBarNewButtonMenu/TopBarNewButton"
import { CreateOrderType } from "../../components/createOrder/helpers"
import {
    TopBarNewButtonMenu,
    UserActionsMenuItemConfig,
} from "../../components/topBarNewButtonMenu/TopBarNewButtonMenu"
import { useMatchEnvironment } from "../../../modules/environment/envHooks"
import { EnvironmentType } from "../../../modules/environment/envTypes"

type CrateOrderButtonProps = {
    isMerchantUser?: boolean
}

export function MainTopBarNewButton({ isMerchantUser }: CrateOrderButtonProps) {
    const { openDialog } = useOrderDialogUrlState()
    const enableMeetingService = useMatchEnvironment([EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo, EnvironmentType.QA])

    const [isCreateMessageOpen, setIsCreateMessageOpen] = useState(false)

    const handleCreateOrder = (activeOrderTab?: CreateOrderType) => {
        openDialog({ activeOrderTab })
    }

    const handleOpenCreateMessage = () => {
        setIsCreateMessageOpen(true)
    }

    const handleCloseCreateMessage = () => {
        setIsCreateMessageOpen(false)
    }

    if (isMerchantUser) {
        const items: UserActionsMenuItemConfig[] = [
            createTopBarNewMenuItem("push-message", handleOpenCreateMessage),
        ]

        if (enableMeetingService) {
            const meetingServiceItem = createTopBarNewMenuItem("meeting-service", () => handleCreateOrder(CreateOrderType.MEETING_SERVICE))
            items.unshift(meetingServiceItem)
        }

        return (
            <>
                <TopBarNewButtonMenu items={items} />
                {isCreateMessageOpen && (
                    <CreateMessageDialog open={isCreateMessageOpen} onClose={handleCloseCreateMessage} />
                )}
            </>
        )
    }

    return <TopBarNewButton onClick={() => handleCreateOrder()} />
}
